import { render } from "./TermsAndConditionsManagement.vue?vue&type=template&id=08e092ac&scoped=true"
import script from "./TermsAndConditionsManagement.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsManagement.vue?vue&type=script&lang=js"

import "./TermsAndConditionsManagement.vue?vue&type=style&index=0&id=08e092ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e092ac"]])

export default __exports__